import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogDetail from './pages/BlogDetail';
import Berbagi from './pages/Berbagi';
import Login from './pages/Login';
import NotFound from './pages/NotFound';

import AdminDashboard from './pages/admin/AdminDashboard';
import AdminHome from './pages/admin/AdminHome';
import AdminPost from './pages/admin/AdminPost';
import AdminSettings from './pages/admin/AdminSettings';
import AdminPostCreate from './pages/admin/AdminPostCreate';
import AdminPostEdit from './pages/admin/AdminPostEdit';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminStories from './pages/admin/AdminStories';
import { AuthProvider } from './pages/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/berbagi" element={<Berbagi />} />
          <Route path="/login" element={<Login />} />
          <Route path="/post/:id" element={<BlogDetail />} />

          {/* Admin routes protected */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminHome />} />
            <Route path="post" element={<AdminPost />} />
            <Route path="post/new" element={<AdminPostCreate />} />
            <Route path="post/edit/:id" element={<AdminPostEdit />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="stories" element={<AdminStories />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 
